import React from "react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../../components/ui/hover-card";
import { Button } from "../../components/ui/button";

interface HelpHoverCardProps {
  title: string;
  description: string;
}

const HelpHoverCard = ({ title, description }: HelpHoverCardProps) => {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button variant="outline" size="sm" className="text-xs">
          How it works
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="w-80 space-y-2">
        <p className="text-sm font-medium">{title}</p>
        <p className="text-xs text-muted-foreground">{description}</p>
      </HoverCardContent>
    </HoverCard>
  );
};

export default HelpHoverCard;
